import HomeIconInactive from "../images/icons/homeIconInactive.svg?react";
import HomeIconActive from "../images/icons/homeIconActive.svg?react";
import ExploreIconActive from "../images/icons/exploreIconActive.svg?react";
import ExploreIconInactive from "../images/icons/exploreIconInactive.svg?react";
import PlusIcon from "../images/icons/plusThink.svg?react";
import PlusThinkActive from "../images/icons/plusThinkActive.svg?react";
import ProfileIconActive from "../images/icons/profileIconActive.svg?react";
import ProfileIconInactive from "../images/icons/profileIconInactive.svg?react";
import NicheIcon from "../images/icons/niche.svg?react";
import NicheIconActive from "../images/icons/niche-filled.svg?react";
import { useMemo } from "react";
import { ExploreType, routes } from "@/common/utils/routes";
import { TABS_LABELS, TABS_URLS } from "../helpers";
import { useExitSnapFeed } from "./useExitSnapFeed";

type IsTabActive = (tab: string) => string | boolean | null;

interface UseFooterMenuItemsParams {
  currentUserName: string | null;
  isTabActive: IsTabActive;
  onSendMetricAndCloseMenu: (
    tabName: TABS_URLS,
    label: TABS_LABELS,
    targetUrl: string,
  ) => void;
  onProfileClick: () => void;
  isProfileMenuOpen: boolean;
  isVerified: boolean;
}

export const useFooterMenuItems = ({
  currentUserName,
  isTabActive,
  onSendMetricAndCloseMenu,
  onProfileClick,
  isProfileMenuOpen,
  isVerified,
}: UseFooterMenuItemsParams) => {
  const exitSnapFeed = useExitSnapFeed();

  const isTabActiveFor = (tab: TABS_URLS): boolean =>
    !isProfileMenuOpen && !!isTabActive(tab);

  const menuItems = useMemo(() => ([
    {
      icon: isTabActiveFor(TABS_URLS.home) ? HomeIconActive : HomeIconInactive,
      link: routes.home(),
      title: TABS_LABELS.home,
      onClick: () => {
        if (isTabActiveFor(TABS_URLS.home)) {
          exitSnapFeed();
        }

        onSendMetricAndCloseMenu(TABS_URLS.home, TABS_LABELS.home, routes.home());
      },
      isActive: isTabActiveFor(TABS_URLS.home)
    },
    {
      icon: isTabActiveFor(TABS_URLS.explore) ? ExploreIconActive : ExploreIconInactive,
      link: routes.explore(ExploreType.gifs),
      title: TABS_LABELS.explore,
      onClick: () => onSendMetricAndCloseMenu(TABS_URLS.explore, TABS_LABELS.explore, routes.explore(ExploreType.gifs)),
      isActive: isTabActiveFor(TABS_URLS.explore)
    },
    {
      icon: isTabActiveFor(TABS_URLS.add) ? PlusThinkActive : PlusIcon,
      link: routes.create(),
      title: isVerified ? TABS_LABELS.studio : TABS_LABELS.add,
      onClick: () => onSendMetricAndCloseMenu(TABS_URLS.add, TABS_LABELS.add, routes.create()),
      isActive: isTabActiveFor(TABS_URLS.add)
    },
    {
      icon: isTabActiveFor(TABS_URLS.niches) ? NicheIconActive : NicheIcon,
      link: routes.niches(),
      title: TABS_LABELS.niches,
      onClick: () => onSendMetricAndCloseMenu(TABS_URLS.niches, TABS_LABELS.niches, routes.niches()),
      isActive: isTabActiveFor(TABS_URLS.niches)
    },
    {
      icon: isTabActive(TABS_URLS.profile) || isProfileMenuOpen ? ProfileIconActive : ProfileIconInactive,
      title: currentUserName ? "Profile" : "Log in",
      onClick: onProfileClick,
      isActive: !!(isTabActive(TABS_URLS.profile) || isProfileMenuOpen)
    },
  ]), [currentUserName, exitSnapFeed, isProfileMenuOpen, isTabActive, onSendMetricAndCloseMenu, onProfileClick]);

  return menuItems;
};
